// extracted by mini-css-extract-plugin
export default {"alphabet":"style_alphabet__MWSRj","title":"style_title__fuvJ+","card":"style_card__VNqJz"};